import Swiper from 'swiper/bundle';
import $ from 'jquery';

export default () => {
  function sliderRender() {
    const mainTarget = '.product-images__main-slider';
    const navTarget = '.product-images__nav';

    if (!document.querySelector(mainTarget)) {
      return;
    }

    const initSlide = parseInt(
      document.querySelector(mainTarget).dataset.swiperInitialslide,
    );

    const navSlider = new Swiper(navTarget, {
      spaceBetween: 0,
      slidesPerView: 8,
      freeMode: false,
      navigation: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      hashNavigation: {
        watchState: true,
      },
    });

    const mainSlider = new Swiper(mainTarget, {
      slidesPerView: 1,
      loop: false,
      zoom: true,
      initialSlide: initSlide,
      hashNavigation: {
        watchState: true,
      },
      navigation: {
        nextEl: '.swiper-button-next--main-slider',
        prevEl: '.swiper-button-prev--main-slider',
      },
      pagination: {
        el: '.swiper-pagination--main-slider',
        type: 'bullets',
        clickable: 'true',
      },
      thumbs: {
        swiper: navSlider,
      },
    });

    Karmoon.EventBus.listen('variantChanged:changed', (variant) => {
      mainSlider.slideTo(getSlideIndexByClass(variant));
    });

    mainSlider.on('slideChange', () => {
      const swatchTitle = document.querySelector(
        '[js-product-swatches="swatchTitleContainer"]',
      );

      if (!swatchTitle) {
        return;
      }
      swatchTitle.innerHTML = '';
    });
  }

  function getSlideIndexByClass(className) {
    let index = 0;
    $.each(
      $('.product-images__main-slider .swiper-wrapper').children(),
      (i, item) => {
        if ($(item).hasClass(className)) {
          index = i;
          return false;
        }
      },
    );
    // console.log(index);
    return index;
  }

  function init() {
    sliderRender();
  }

  /**
   * Public interface.
   */
  return Object.freeze({
    init,
  });
};
